export default __webpack_public_path__ + "static/media/B_lopetus5.dc9def4f.mp3";